<fgb-banner [bannerTitle]="'earn.page.title' | translate"></fgb-banner>

<fgb-page-header [pageTitle]="'earn.page.title'" [backButtonLink]="'/'" [showBalance]="false" [showQr]="false"></fgb-page-header>

<div class="container earn-points-container">
  <fgbcl-earn-points [lgWidth]="4"></fgbcl-earn-points>
</div>
